import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, submit, Form } from "redux-form";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  FormControlLabel,
  TextField,
  withMobileDialog,
  withStyles,
  Checkbox,
  Grid
} from "@material-ui/core";
import * as AccountActions from "../store/AccountHierarchy";
import * as SnackbarActions from "../store/SnackbarStore";
import {
  CreateHierarchyElement,
  UpdateHierarchyElement
} from "../services/hierarchyService";
import styles from "../wrappers/admin/Admin.Styles";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
const maxLength256 = maxLength(256);

const validate = values => {
  const errors = {};
  const requiredFields = ["name"];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  const maxLengthFields = ["name", "alias"];
  maxLengthFields.forEach(field => {
    if (maxLength256(values[field])) {
      errors[field] = maxLength256(values[field]);
    }
  });

  return errors;
};

const renderTextField = ({
  input,
  label,
  name,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <TextField
      name={name}
      label={label}
      helperText={touched && error}
      error={touched && error !== undefined}
      {...input}
      {...custom}
      margin="normal"
    />
  );
};

const renderCheckbox = ({ input, label, name, ...custom }) => {
  //debugger;
  return (
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          label={label}
          {...input}
          checked={input.value}
          value={input.value ? "yes" : "no"}
          {...custom}
        />
      }
      label={label}
    />
  );
};

export const RollupFormMode = Object.freeze({
  CREATE: Symbol("create"),
  EDIT: Symbol("edit")
});

class RollupForm extends Component {
  handleSubmit = async hierarchyElement => {
    const { sendError } = this.props;

    try {
      const mode =
        hierarchyElement.id > 0 ? RollupFormMode.EDIT : RollupFormMode.CREATE;
      const result =
        hierarchyElement.id > 0
          ? await UpdateHierarchyElement(hierarchyElement)
          : await CreateHierarchyElement(hierarchyElement);

      if (result) {
        this.props.submitted(result, mode);
      }
    } catch (error) {
      console.log(error);
      sendError(error);
    }
  };

  render() {
    const { classes, handleSubmit, isEditItem, hierarchyTypeId } = this.props;

    return (
      <div className={classes.root}>
        <Form onSubmit={handleSubmit(this.handleSubmit)}>
          <Grid container spacing={24} />
          {!isEditItem ? (
            <Grid item xs={12}>
              <Field
                name="name"
                component={renderTextField}
                label="Name"
                className={classes.textFieldMed}
              />
            </Grid>
          ) : (
            undefined
          )}

          <Grid item xs={12}>
            <Field
              name="alias"
              component={renderTextField}
              label="Alias"
              className={classes.textFieldMed}
            />
          </Grid>
          {isEditItem && hierarchyTypeId === 1 ? (
            <Grid item xs={12}>
              <Field
                name="invertSign"
                component={renderCheckbox}
                label="Invert Sign"
              />
            </Grid>
          ) : (
            undefined
          )}
        </Form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    initialValues: state.rollupModal.data
  };
}

RollupForm = connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        SnackbarActions.actionCreators,
        AccountActions.actionCreators
      ),
      dispatch
    )
)(
  reduxForm({
    form: "RollupForm",
    validate
  })(withStyles(styles)(RollupForm))
);

class RollupModalForm extends Component {
  state = {
    hierarchyElement: {
      name: "",
      invertSign: false
    }
  };

  getTitle = () => {
    if (this.state.hierarchyElement.entityId) {
      return `Edit ${this.state.hierarchyElement.name}`;
    } else {
      return this.state.hierarchyElement.id ? "Edit Rollup" : "Add Rollup";
    }
  };

  componentDidMount() {
    const { initialValues } = this.props;
    this.setState({ hierarchyElement: { ...initialValues } });
  }

  render() {
    const {
      open,
      fullscreen,
      handleClose,
      dispatch,
      hierarchyTypeId
    } = this.props;
    const isEditItem = this.state.hierarchyElement.entityId ? true : false;

    return (
      <Dialog
        fullscreen={fullscreen}
        open={open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {this.getTitle()}
        </DialogTitle>
        <DialogContent>
          <RollupForm
            submitted={handleClose}
            isEditItem={isEditItem}
            hierarchyTypeId={hierarchyTypeId}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(submit("RollupForm"));
            }}
            color="primary"
          >
            Ok
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

RollupModalForm.propTypes = {
  open: PropTypes.bool.isRequired,
  hierarchyTypeId: PropTypes.number
};

export default connect(state => ({
  initialValues: state.rollupModal.data
}))(withStyles(styles)(withMobileDialog()(RollupModalForm)));
